(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var dialog = document.querySelector('[data-cart-confirm]');
    if (!dialog) return;

    var body = dialog.querySelector('[data-confirm-body]');
    var okBtn = dialog.querySelector('[data-confirm-ok]');
    var cancelBtn = dialog.querySelector('[data-confirm-cancel]');
    var bodyTemplate = body.textContent;
    var pendingUrl = null;

    document.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        pendingUrl = btn.dataset.removeUrl;
        var title = btn.dataset.itemTitle;
        body.textContent = title
          ? bodyTemplate.replace(/this item/i, '"' + title + '"')
          : bodyTemplate;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          if (confirm(body.textContent)) window.location.href = pendingUrl;
        }
      });
    });

    cancelBtn.addEventListener('click', function() {
      dialog.close();
      pendingUrl = null;
    });

    okBtn.addEventListener('click', function() {
      if (pendingUrl) window.location.href = pendingUrl;
    });

    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) {
        dialog.close();
        pendingUrl = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    /* Sort */
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location);
        url.searchParams.set('sort_by', this.value);
        window.location = url.toString();
      });
    }

    /* Mobile filter toggle */
    var filterToggle = document.querySelector('[data-filter-toggle]');
    var filterSidebar = document.querySelector('[data-filter-sidebar]');
    if (filterToggle && filterSidebar) {
      filterToggle.addEventListener('click', function() {
        filterSidebar.classList.toggle('sds-collection__sidebar-content--open');
      });
    }

    /* Filter form submission */
    var filterForm = document.querySelector('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(filterForm);
        var url = new URL(window.location.origin + window.location.pathname);

        /* Preserve sort_by */
        var currentUrl = new URL(window.location);
        var sortBy = currentUrl.searchParams.get('sort_by');
        if (sortBy) url.searchParams.set('sort_by', sortBy);

        /* Build filter params */
        for (var pair of formData.entries()) {
          var key = pair[0];
          var val = pair[1];
          if (val !== '' && val !== '0') {
            url.searchParams.append(key, val);
          }
        }

        window.location = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    var btn = document.querySelector('[data-theme-switch]');
    if (!btn) return;

    var root = document.documentElement;
    var stored = localStorage.getItem('sds-theme');

    if (stored === 'dark') {
      root.setAttribute('data-theme', 'dark');
    } else if (stored === 'light') {
      root.removeAttribute('data-theme');
    } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      root.setAttribute('data-theme', 'dark');
    }

    btn.addEventListener('click', function() {
      var isDark = root.getAttribute('data-theme') === 'dark';
      if (isDark) {
        root.removeAttribute('data-theme');
        localStorage.setItem('sds-theme', 'light');
      } else {
        root.setAttribute('data-theme', 'dark');
        localStorage.setItem('sds-theme', 'dark');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('.sds-header');
    if (!header) return;

    var menu = header.querySelector('[data-mobile-menu]');
    var openBtn = header.querySelector('[data-mobile-menu-open]');
    var closeBtns = header.querySelectorAll('[data-mobile-menu-close]');

    function openMenu() {
      menu.classList.add('sds-header__mobile-menu--open');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menu.classList.remove('sds-header__mobile-menu--open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openMenu);
    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closeMenu);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    /* Variant logic */
    var section = document.querySelector('.sds-pdp');
    if (!section) return;

    var variantsJson = document.querySelector('[data-product-variants]');
    if (!variantsJson) return;
    var variants = JSON.parse(variantsJson.textContent);

    var imageMapJson = document.querySelector('[data-variant-image-map]');
    var variantImageMap = imageMapJson ? JSON.parse(imageMapJson.textContent) : {};

    var moneyFormatEl = document.querySelector('[data-money-format]');
    var moneyFormat = moneyFormatEl ? moneyFormatEl.textContent.trim() : '{{amount}}';
    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        try { return formatMoney(cents, moneyFormat); } catch (e) {}
      }
      var value = cents / 100;
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, key) {
        switch (key) {
          case 'amount': return value.toFixed(2);
          case 'amount_no_decimals': return Math.round(value).toString();
          case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',');
          case 'amount_no_decimals_with_comma_separator': return Math.round(value).toString();
          case 'amount_with_space_separator': return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          case 'amount_with_period_and_space_separator': return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',');
          case 'amount_with_apostrophe_separator': return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
          default: return value.toFixed(2);
        }
      });
    }

    var i18nJson = document.querySelector('[data-product-i18n]');
    var i18n = i18nJson ? JSON.parse(i18nJson.textContent) : { add_to_cart: 'Add to cart', sold_out: 'Sold out' };

    var variantInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('.sds-pdp__price');
    var compareEl = section.querySelector('.sds-pdp__compare-price');
    var atcBtn = section.querySelector('.sds-pdp__atc');

    /* Gather all option inputs (radios for color, selects for others) */
    var optionInputs = section.querySelectorAll('[data-option-position]');

    function onOptionChange() {
      /* For color swatches: update visual state */
      var radio = this;
      if (radio.type === 'radio') {
        var parent = radio.closest('.sds-pdp__color-swatches');
        if (parent) {
          parent.querySelectorAll('.sds-pdp__swatch').forEach(function(s) {
            s.classList.remove('sds-pdp__swatch--active');
          });
          radio.closest('.sds-pdp__swatch').classList.add('sds-pdp__swatch--active');
        }
      }

      /* Build selected options */
      var selectedOptions = {};
      optionInputs.forEach(function(inp) {
        if (inp.type === 'radio' && !inp.checked) return;
        selectedOptions['option' + inp.dataset.optionPosition] = inp.value;
      });

      /* Find matching variant */
      var matched = variants.find(function(v) {
        var match = true;
        Object.keys(selectedOptions).forEach(function(key) {
          if (v[key] !== selectedOptions[key]) match = false;
        });
        return match;
      });

      if (matched) {
        variantInput.value = matched.id;

        if (priceEl) {
          priceEl.textContent = formatMoney(matched.price);
        }

        if (compareEl) {
          if (matched.compare_at_price && matched.compare_at_price > matched.price) {
            compareEl.textContent = formatMoney(matched.compare_at_price);
            compareEl.style.display = '';
          } else if (compareEl) {
            compareEl.style.display = 'none';
          }
        }

        if (atcBtn) {
          var label = atcBtn.querySelector('.sds-btn__label');
          if (matched.available) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('sds-btn--disabled');
            if (label) label.textContent = i18n.add_to_cart;
          } else {
            atcBtn.disabled = true;
            atcBtn.classList.add('sds-btn--disabled');
            if (label) label.textContent = i18n.sold_out;
          }
        }

        var url = new URL(window.location);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url);

        /* Swap gallery to the variant's featured image */
        var slide = null;
        var mappedPos = variantImageMap[matched.id];
        if (mappedPos !== undefined) {
          slide = section.querySelector('[data-image-position="' + mappedPos + '"]');
        }
        if (!slide && matched.featured_image && matched.featured_image.id) {
          slide = section.querySelector('[data-image-id="' + matched.featured_image.id + '"]');
        }
        if (slide) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }
    }

    optionInputs.forEach(function(inp) {
      inp.addEventListener('change', onOptionChange);
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
